module.exports = require("@swa-ui/shopping/src/ChildAgeSelector/ChildAgeSelector.module.scss");